module.exports = __webpack_public_path__ + "img/finland-pregnancy-childbirth-and-the-puerperium-female.7dc18cdb.png";